import React, { useCallback, useEffect } from 'react';
import useEmbla from 'embla-carousel-react';
import { CarouselItem } from './carousel-item';
import { CampaignUserDtoRead } from '@/store/services/MidleNestApi.service';
import { Avatar } from '@/components';
import classNames from 'classnames';
import Autoplay from 'embla-carousel-autoplay';

type Props = {
  campaigns: CampaignUserDtoRead[];
};

export default function TaskCarousel({ campaigns }: Props) {
  const [ref, emblaApi] = useEmbla({ loop: true, containScroll: 'trimSnaps' }, [
    Autoplay({ delay: 6000 }),
  ]);
  const [currentSlide, setCurrentSlide] = React.useState(0);

  const prev = useCallback(() => {
    if (!emblaApi) return;
    emblaApi.scrollPrev();
  }, [emblaApi]);

  const next = useCallback(() => {
    if (!emblaApi) return;
    emblaApi.scrollNext();
  }, [emblaApi]);

  // const campaigns = useMemo(() => data?.campaigns, [data, isLoading]);
  if (!campaigns || campaigns.length < 1) return null;

  useEffect(() => {
    emblaApi?.on('select', (e) => {
      setCurrentSlide(emblaApi.selectedScrollSnap());
    });
  }, [emblaApi]);

  return (
    <div className='flex flex-col w-full'>
      {campaigns && (
        <div className='w-full overflow-hidden' ref={ref}>
          <div className='flex w-full'>
            {campaigns.map((i) => (
              <CarouselItem {...i} key={i.id} />
            ))}
          </div>
        </div>
      )}

      {campaigns && campaigns.length > 1 && (
        <div className='flex items-center justify-center mt-4 space-x-2'>
          <button type='button' onClick={prev}>
            <i className='icon-angle-left dark:text-white text-xl' />
          </button>
          {campaigns.map((campaign, index) => (
            <div
              onClick={() => emblaApi?.scrollTo(index)}
              key={index}
              className={'w-max h-max cursor-pointer'}
            >
              <Avatar
                name={campaign.customer.profile.user.name || ''}
                className={classNames(
                  'w-12 h-12 transition-all duration-300',
                  currentSlide === index
                    ? 'scale-125 border-2 border-[#1A56DB] dark:border-[#FFDA68]'
                    : 'opacity-40',
                )}
                src={campaign.customer.profile.avatar?.src}
              />
            </div>
          ))}
          <button type='button' onClick={next}>
            <i className='icon-angle-right dark:text-white text-xl' />
          </button>
        </div>
      )}
    </div>
  );
}
